<span>{{ (cellValue | number: '1.0-0') || '-' }}</span>
